export default "__VITE_ASSET__a0f4f51d__"